// extracted by mini-css-extract-plugin
export var modal = "_fg-0";